<!-- 正常群との比較レーダーチャート -->
<template>
  <div class="small">
    <radar-chart :chartdata="chartdata" :options="options" />
  </div>
</template>

<script>
import VueTypes from "vue-types";
import RadarChart from "./RadarChart.js";

export default {
  components: {
    RadarChart,
  },
  data() {
    return {
      options: {
        responsive: true,
        legend: {
          position: "bottom",
        },
        scale: {
          ticks: {
            max: 1,
            beginAtZero: true,
            display: false,
            stepSize: 0.2,
          },
        },
      },
    };
  },
  props: {
    groupAnalysis: VueTypes.arrayOf(VueTypes.object).isRequired,
    name: VueTypes.string.isRequired,
  },
  computed: {
    chartdata() {
      return {
        labels: [
          this.$store.state.labels.factorLabels[this.groupAnalysis[0].factor],
          this.$store.state.labels.factorLabels[this.groupAnalysis[1].factor],
          this.$store.state.labels.factorLabels[this.groupAnalysis[2].factor],
          this.$store.state.labels.factorLabels[this.groupAnalysis[3].factor],
          this.$store.state.labels.factorLabels[this.groupAnalysis[4].factor],
        ],
        datasets: [
          {
            label: this.$t("aiPredictionReport.normal"),
            backgroundColor: "rgba(211, 229, 211, 0.5)",
            borderColor: "rgba(0, 0, 0, 0)",
            data: this.valueGroupAvg,
            pointRadius: 0,
          },
          {
            label: `${this.name}様`,
            backgroundColor: "rgba(241, 222, 203, 0.5)",
            borderColor: "rgba(0, 0, 0, 0)",
            data: this.valueUser,
            pointRadius: 0,
          },
        ],
      };
    },
    valueGroupAvg() {
      return this.groupAnalysis.map((e) => {
        if (e.value_group_avg >= 1) {
          return 1;
        } else if (e.value_group_avg < 0) {
          return 0;
        }
        return e.value_group_avg;
      });
    },
    valueUser() {
      return this.groupAnalysis.map((e) => {
        if (e.value >= 1) {
          return 1;
        } else if (e.value < 0) {
          return 0;
        }
        return e.value;
      });
    },
  },
};
</script>

<style scoped>
.small {
  max-width: 300px;
  margin: auto;
}
</style>
